import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export enum RoutesIds {
  admin = 'admin',
  notifications = 'notifications',
  secrets = 'secrets',
  secret = 'secret',
  policies = 'policies',
  groups = 'groups',
  group = 'group',
  users = 'users',
  user = 'user',
  invitations = 'invitations',
  agents = 'agents',
  agent = 'agent',
  apiClients = 'apiClients',
  apiClient = 'apiClient',
  clients = 'clients',
  client = 'client',
  clientSchema = 'clientSchema',
  clientMonitoring = 'clientMonitoring',
  roles = 'roles',
  oauthApps = 'oauthApps',
  oauthApp = 'oauthApp',
  metricsDataWarehouse = 'metricsDataWarehouse',
  reports = 'reports',
  github = 'github',
  cursorIntegration = 'cursorIntegration',
  workflows = 'workflows',
  workflow = 'workflow',
  workflowInstances = 'workflowInstances',
  workflowInstanceOverview = 'workflowInstanceOverview',
  workflowInstanceEvents = 'workflowInstanceEvents',
  workflowLogs = 'workflowLogs',
  workflowTunnels = 'workflowTunnels',
  flagAppliedConnections = 'flagAppliedConnections',
  flagAppliedConnection = 'flagAppliedConnection',
  eventConnections = 'eventConnections',
  eventConnection = 'eventConnection',
  activityFeeds = 'activityFeeds',
  environments = 'environments',
  assignmentTables = 'assignmentTables',
  assignmentTable = 'assignmentTable',
  assignmentTablesCreate = 'assignmentTablesCreate',
  assignmentTableEdit = 'assignmentTableEdit',
  factTables = 'factTables',
  factTable = 'factTable',
  factTablesCreate = 'factTablesCreate',
  factTableEdit = 'factTableEdit',
  entities = 'entities',
  entity = 'entity',
  entityRelationTable = 'entityRelationTable',
  entityRelationTableCreate = 'entityRelationTableCreate',
  dimensionTables = 'dimensionTables',
  dimensionTable = 'dimensionTable',
  dimensionTableEdit = 'dimensionTableEdit',
  dimensionTablesCreate = 'dimensionTablesCreate',
  labels = 'labels',
  label = 'label',
  dataAgent = 'dataAgent',
  collections = 'collections',
  collection = 'collection',
}

enum ExternalRoutesIds {
  metrics = 'metrics',
}

export const metricsExternalRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.metrics,
  optional: true,
});

// root route
export const adminRouteRef = createRouteRef({ id: RoutesIds.admin });

export const rootRouteRef = adminRouteRef;

// sub-routes within the plugin
export const notificationsRouteRef = createSubRouteRef({
  id: RoutesIds.notifications,
  parent: rootRouteRef,
  path: '/notifications',
});

export const workflowSecretsRouteRef = createSubRouteRef({
  id: RoutesIds.secrets,
  parent: rootRouteRef,
  path: '/workflow-secrets',
});

export const workflowSecretRouteRef = createSubRouteRef({
  id: RoutesIds.secret,
  parent: rootRouteRef,
  path: '/workflow-secrets/:id',
});

export const policiesRouteRef = createSubRouteRef({
  id: RoutesIds.policies,
  parent: rootRouteRef,
  path: '/policies',
});

export const groupsRouteRef = createSubRouteRef({
  id: RoutesIds.groups,
  parent: rootRouteRef,
  path: '/groups',
});

export const groupRouteRef = createSubRouteRef({
  id: RoutesIds.group,
  parent: rootRouteRef,
  path: '/groups/:id',
});

export const usersRouteRef = createSubRouteRef({
  id: RoutesIds.users,
  parent: rootRouteRef,
  path: '/users',
});

export const invitationsRouteRef = createSubRouteRef({
  id: RoutesIds.invitations,
  parent: rootRouteRef,
  path: '/users/invitations',
});

export const userRouteRef = createSubRouteRef({
  id: RoutesIds.user,
  parent: rootRouteRef,
  path: '/users/:id',
});

export const agentsRouteRef = createSubRouteRef({
  id: RoutesIds.agents,
  parent: rootRouteRef,
  path: '/agents',
});

export const agentRouteRef = createSubRouteRef({
  id: RoutesIds.agent,
  parent: rootRouteRef,
  path: '/agents/:id',
});

export const apiClientsRouteRef = createSubRouteRef({
  id: RoutesIds.apiClients,
  parent: rootRouteRef,
  path: '/api-clients',
});

export const apiClientRouteRef = createSubRouteRef({
  id: RoutesIds.apiClient,
  parent: rootRouteRef,
  path: '/api-clients/:id',
});

export const clientsRouteRef = createSubRouteRef({
  id: RoutesIds.clients,
  parent: rootRouteRef,
  path: '/clients',
});

export const clientRouteRef = createSubRouteRef({
  id: RoutesIds.client,
  parent: rootRouteRef,
  path: '/clients/:id',
});

export const clientSchemaRouteRef = createSubRouteRef({
  id: RoutesIds.clientSchema,
  parent: rootRouteRef,
  path: '/clients/schema',
});

export const clientMonitoringRouteRef = createSubRouteRef({
  id: RoutesIds.clientMonitoring,
  parent: rootRouteRef,
  path: '/clients/monitoring',
});

export const rolesRouteRef = createSubRouteRef({
  id: RoutesIds.roles,
  parent: rootRouteRef,
  path: '/roles',
});

export const oauthAppsRouteRef = createSubRouteRef({
  id: RoutesIds.oauthApps,
  parent: rootRouteRef,
  path: '/oauth-apps',
});

export const oauthAppRouteRef = createSubRouteRef({
  id: RoutesIds.oauthApp,
  parent: rootRouteRef,
  path: '/oauth-apps/:id',
});

export const metricsDataWarehouseRouteRef = createSubRouteRef({
  id: RoutesIds.metricsDataWarehouse,
  parent: rootRouteRef,
  path: '/metrics-datawarehouse',
});

export const reportsRouteRef = createSubRouteRef({
  id: RoutesIds.reports,
  parent: rootRouteRef,
  path: '/reports',
});

export const githubRouteRef = createSubRouteRef({
  id: RoutesIds.github,
  parent: rootRouteRef,
  path: '/github',
});

export const cursorIntegrationRouteRef = createSubRouteRef({
  id: RoutesIds.cursorIntegration,
  parent: rootRouteRef,
  path: '/cursor-integration',
});

export const workflowsRouteRef = createSubRouteRef({
  id: RoutesIds.workflows,
  parent: rootRouteRef,
  path: '/workflows',
});

export const workflowRouteRef = createSubRouteRef({
  id: RoutesIds.workflow,
  parent: rootRouteRef,
  path: '/workflows/:id',
});

export const workflowInstancesRouteRef = createSubRouteRef({
  id: RoutesIds.workflowInstances,
  parent: rootRouteRef,
  path: '/workflows/:id/instances',
});

export const workflowInstanceOverviewRouteRef = createSubRouteRef({
  id: RoutesIds.workflowInstanceOverview,
  parent: rootRouteRef,
  path: '/workflows/:id/instances/:instance',
});

export const workflowInstanceEventsRouteRef = createSubRouteRef({
  id: RoutesIds.workflowInstanceEvents,
  parent: rootRouteRef,
  path: '/workflows/:id/instances/:instance/events',
});

export const workflowLogsRouteRef = createSubRouteRef({
  id: RoutesIds.workflowLogs,
  parent: rootRouteRef,
  path: '/workflows/:id/logs',
});

export const workflowTunnelsRouteRef = createSubRouteRef({
  id: RoutesIds.workflowTunnels,
  parent: rootRouteRef,
  path: '/workflows/:id/tunnels',
});

export const flagAppliedConnectionsRouteRef = createSubRouteRef({
  id: RoutesIds.flagAppliedConnections,
  parent: rootRouteRef,
  path: '/connections/flag-applied',
});

export const flagAppliedConnectionRouteRef = createSubRouteRef({
  id: RoutesIds.flagAppliedConnection,
  parent: rootRouteRef,
  path: '/connections/flag-applied/:id',
});

export const eventConnectionsRouteRef = createSubRouteRef({
  id: RoutesIds.eventConnections,
  parent: rootRouteRef,
  path: '/connections/event',
});

export const eventConnectionRouteRef = createSubRouteRef({
  id: RoutesIds.eventConnection,
  parent: rootRouteRef,
  path: '/connections/event/:id',
});

export const activityFeedsRouteRef = createSubRouteRef({
  id: RoutesIds.activityFeeds,
  parent: rootRouteRef,
  path: '/activity-feeds',
});

export const environmentsRouteRef = createSubRouteRef({
  id: RoutesIds.environments,
  parent: rootRouteRef,
  path: '/environments',
});

export const assignmentTablesRouteRef = createSubRouteRef({
  id: RoutesIds.assignmentTables,
  parent: rootRouteRef,
  path: '/assignment-tables',
});

export const assignmentTableRouteRef = createSubRouteRef({
  id: RoutesIds.assignmentTable,
  parent: rootRouteRef,
  path: '/assignment-tables/:id',
});

export const assignmentTablesEditRouteRef = createSubRouteRef({
  id: RoutesIds.assignmentTableEdit,
  path: '/assignment-tables/:id/edit',
  parent: rootRouteRef,
});

export const assignmentTablesCreateRouteRef = createSubRouteRef({
  id: RoutesIds.assignmentTablesCreate,
  path: '/assignment-tables-create',
  parent: rootRouteRef,
});

export const factTablesRouteRef = createSubRouteRef({
  id: RoutesIds.factTables,
  path: '/fact-tables',
  parent: rootRouteRef,
});

export const factTablesCreateRouteRef = createSubRouteRef({
  id: RoutesIds.factTablesCreate,
  path: '/fact-tables-create',
  parent: rootRouteRef,
});

export const factTableRouteRef = createSubRouteRef({
  id: RoutesIds.factTable,
  path: '/fact-tables/:id',
  parent: rootRouteRef,
});

export const factTableEditRouteRef = createSubRouteRef({
  id: RoutesIds.factTableEdit,
  path: '/fact-tables/:id/edit',
  parent: rootRouteRef,
});

export const entitiesRouteRef = createSubRouteRef({
  id: RoutesIds.entities,
  path: '/entities',
  parent: rootRouteRef,
});

export const entityRelationTableRouteRef = createSubRouteRef({
  id: RoutesIds.entityRelationTable,
  path: '/entities/:entityId/entityRelationTables/:entityRelationTableId',
  parent: rootRouteRef,
});

export const entityRelationTablesCreateRouteRef = createSubRouteRef({
  id: RoutesIds.entityRelationTableCreate,
  path: '/entity-relation-table-create/:parentEntityId',
  parent: rootRouteRef,
});

export const entityRouteRef = createSubRouteRef({
  id: RoutesIds.entity,
  path: '/entities/:id',
  parent: rootRouteRef,
});

export const dimensionTablesRouteRef = createSubRouteRef({
  id: RoutesIds.dimensionTables,
  path: '/dimension-tables',
  parent: rootRouteRef,
});

export const dimensionTableRouteRef = createSubRouteRef({
  id: RoutesIds.dimensionTable,
  path: '/dimension-tables/:id',
  parent: rootRouteRef,
});

export const dimensionTableRouteEditRef = createSubRouteRef({
  id: RoutesIds.dimensionTableEdit,
  path: '/dimension-tables/:id/edit',
  parent: rootRouteRef,
});

export const dimensionTableCreateRouteRef = createSubRouteRef({
  id: RoutesIds.dimensionTablesCreate,
  path: '/dimension-tables-create',
  parent: rootRouteRef,
});

export const labelsRouteRef = createSubRouteRef({
  id: RoutesIds.labels,
  parent: rootRouteRef,
  path: '/labels',
});

export const labelRouteRef = createSubRouteRef({
  id: RoutesIds.label,
  parent: rootRouteRef,
  path: '/labels/:id',
});

export const dataAgentRouteRef = createSubRouteRef({
  id: RoutesIds.dataAgent,
  parent: rootRouteRef,
  path: '/data-agent',
});

export const collectionsRouteRef = createSubRouteRef({
  id: RoutesIds.collections,
  parent: rootRouteRef,
  path: '/collections',
});

export const collectionRouteRef = createSubRouteRef({
  id: RoutesIds.collection,
  parent: rootRouteRef,
  path: '/collections/:id',
});

// default routes/routes to be used by other plugins
export const Routes = {
  admin: adminRouteRef,
  notifications: notificationsRouteRef,
  secrets: workflowSecretsRouteRef,
  secret: workflowSecretRouteRef,
  policies: policiesRouteRef,
  groups: groupsRouteRef,
  group: groupRouteRef,
  users: usersRouteRef,
  user: userRouteRef,
  invitations: invitationsRouteRef,
  agents: agentsRouteRef,
  agent: agentRouteRef,
  apiClients: apiClientsRouteRef,
  apiClient: apiClientRouteRef,
  clients: clientsRouteRef,
  client: clientRouteRef,
  clientSchema: clientSchemaRouteRef,
  clientMonitoring: clientMonitoringRouteRef,
  roles: rolesRouteRef,
  oauthApps: oauthAppsRouteRef,
  oauthApp: oauthAppRouteRef,
  metricsDataWarehouse: metricsDataWarehouseRouteRef,
  reports: reportsRouteRef,
  workflows: workflowsRouteRef,
  workflow: workflowRouteRef,
  workflowInstances: workflowInstancesRouteRef,
  workflowInstanceOverview: workflowInstanceOverviewRouteRef,
  workflowInstanceEvents: workflowInstanceEventsRouteRef,
  workflowLogs: workflowLogsRouteRef,
  workflowTunnels: workflowTunnelsRouteRef,
  flagAppliedConnections: flagAppliedConnectionsRouteRef,
  flagAppliedConnection: flagAppliedConnectionRouteRef,
  eventConnections: eventConnectionsRouteRef,
  eventConnection: eventConnectionRouteRef,
  activityFeeds: activityFeedsRouteRef,
  environments: environmentsRouteRef,
  assignmentTables: assignmentTablesRouteRef,
  assignmentTable: assignmentTableRouteRef,
  assignmentTablesCreate: assignmentTablesCreateRouteRef,
  assignmentTableEdit: assignmentTablesEditRouteRef,
  factTables: factTablesRouteRef,
  factTable: factTableRouteRef,
  factTablesCreate: factTablesCreateRouteRef,
  factTableEdit: factTableEditRouteRef,
  entities: entitiesRouteRef,
  entity: entityRouteRef,
  entityRelationTable: entityRelationTableRouteRef,
  entityRelationTableCreate: entityRelationTablesCreateRouteRef,
  dimensionTables: dimensionTablesRouteRef,
  dimensionTable: dimensionTableRouteRef,
  dimensionTableEdit: dimensionTableRouteEditRef,
  dimensionTablesCreate: dimensionTableCreateRouteRef,
  github: githubRouteRef,
  cursorIntegration: cursorIntegrationRouteRef,
  labels: labelsRouteRef,
  label: labelRouteRef,
  dataAgent: dataAgentRouteRef,
  collections: collectionsRouteRef,
  collection: collectionRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  metrics: metricsExternalRouteRef,
} satisfies Record<ExternalRoutesIds, ExternalRouteRef>;
